import React, { PureComponent } from 'react';
import { TextArea } from 'semantic-ui-react';
import style from './styles/style.module.css';

export default class DLTextArea extends PureComponent {
    render() {
        const inlineStyle = { ...this.props.style };

        return (
            <div className={ `semantic-wrapper ${ style.semanticTextArea } ${ this.props.className }` }
            data-full-width={ this.props.fullWidth }
            data-name={ this.props.name }
            style={ inlineStyle }>
                { this.props.label &&
                    <label style={ this.props.labelStyle }>{ this.props.label }</label>
                }
                <TextArea className={ `${ style.semanticInput }` }
                value={ this.props.value }
                name={ this.props.name }
                autoFocus={ this.props.autoFocus }
                onChange={ this.props.onChange }
                onKeyDown={ this.props.onKeyDown }
                onFocus={ this.props.onFocus }
                onBlur={ this.props.onBlur }
                required={ this.props.required }
                placeholder={ this.props.placeholder }
                data-error={ !!this.props.error }
                maxLength={ this.props.maxLength }
                label={ this.props.internalLabel } />
                { this.props.hintMessage &&
                    <p className='hint-message' style={ this.props.hintStyle }>{ this.props.hintMessage }</p>
                }
                <p className='error-message'>{ this.props.error }</p>
            </div>
        );
    }
}

DLTextArea.defaultProps = {
    className: '',
    style: {},
    onChange: ()=>{},
    onFocus: ()=>{},
    onBlur: ()=>{},
};
